import { api } from "@/api/client";

export const INSTITUICAO_PATH = "instituicao/Instituicao";
const SCHEDULER_FINANCEIRO_PATH = "scheduller/Financeiro";
const BACKUP_ZIP_PATH = "relatorio/Backup/Zip";

export type SituacaoAdmin = "A" | "T" | "I" | "C" | "E";
export type SituacaoCs = "ON" | "OG" | "EX" | "RE" | "RC";

export interface Instituicao {
  id: number;
  codigo: string;
  razaoSocial: string;
  nomeFantasia: string;
  email: string;
  cnpj: string;
  situacaoAdmin: SituacaoAdmin;
  situacaoCs?: SituacaoCs;
}

export interface InstituicaoFiltro {
  codigo?: string;
  razaoSocial?: string;
  cnpj?: string;
  situacaoAdmin?: string;
  estado?: string;
  situacaoCs?: string;
  financeiro?: string;
  seSaoVicenteDePaulo?: string;
}

export async function downloadBackupAssinados(id: number): Promise<{ blob: Blob; filename: string }> {
  const response = await api.get(`${BACKUP_ZIP_PATH}/${id}`, { responseType: "arraybuffer" });
  return { blob: new Blob([response.data], { type: "application/zip" }), filename: `BackupAssinados${7000 + id}.zip` };
}

export async function atualizarCobrancas(id: number): Promise<void> {
  await api.get(`${SCHEDULER_FINANCEIRO_PATH}/Integracao/AtualizarCobrancas/${id}`);
}
